// src/DebugExtensions.js
import React from 'react';

function DebugExtension() {
  return (
    <div>
      <h1>Debug Extensions</h1>
      <p>This is the debug extensions subpage.</p>
    </div>
  );
}

export default DebugExtension;